import { render, staticRenderFns } from "./modalActivarProyectos.vue?vue&type=template&id=49b89cc4"
import script from "./modalActivarProyectos.vue?vue&type=script&lang=js"
export * from "./modalActivarProyectos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports